import DataSourceQueryContext from '../entities/dataSourceQueryContext';

const DataSourceQueryContextDataTransformationAfterFetch = (data: any) => {
    return data.map((row: any) => {
        return new DataSourceQueryContext(row);
    });
};

export default DataSourceQueryContextDataTransformationAfterFetch;
